import * as React from "react";
import { Text, TextVariant } from "../../../ui";

export const EmptyList: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Text variant={TextVariant.BODY2} className="text-gray-400 px-1 py-6 text-center">
    {children}
  </Text>
);
